export const formatPrice = (price) => {
    if (!price && price !== 0) return '0,00';
    return Number(price).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
